<template>
  <UiSelect
      v-model="model"
      :items="items"
      class="markets-dd"
      :label-key="labelKey"
  >
    <template #top="{item}">
      <div class="markets-dd__item">
        <img :alt="item?.code"
             :src="getImageFromProxy(`https://api.csmarketcap.com/images/${item?.logo || getMarketSvg(item?.logo_name)}`, '50:50')"
             class="wh24 round mr8"
             height="24"
             loading="lazy"
             width="24"
        />
        <span v-if="item?.code">{{ item?.code }}</span>
        <p>{{ item?.name || item?.market_full_name }}</p>
      </div>
    </template>
    <template #default-in="{item}">
      <div class="markets-dd__item">
        <img :alt="item?.code"
             :src="getImageFromProxy(`https://api.csmarketcap.com/images/${item?.logo || getMarketSvg(item?.logo_name)}`, '50:50')"
             class="wh24 round mr8"
             height="24"
             loading="lazy"
             width="24"
        />
        <span>{{ item?.code }}</span>
        <p>{{ item?.name || item?.market_full_name }}</p>
      </div>
    </template>
  </UiSelect>
</template>

<script lang="ts" setup>
import {getImageFromProxy} from "~/utils/get-image-url";

const model = defineModel()
const props = defineProps({
  items: {
    type: Array,
    default: () => []
  },
  labelKey: {
    type: String,
    default: 'name'
  }
})

const getMarketSvg = (str: string)=> {
  if(!str) return ''
  // item?.logo_name.concat('images/markets/').replace('.png', '.svg')
  if ( str.includes('markets/'))
  return str.replace('.png', '.svg')
  return `markets/${str.replace('.png', '.svg')}`
}
</script>

<style lang="scss" scoped>
.markets-dd {
  min-width: 250px;

  .markets-dd__item {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow: hidden;
    p{
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
